import React, { useEffect, useState } from "react";
import { useAlert } from "react-alert";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import api from "../api";
import axios from "axios";
import userAction from "../redux/users/action";
import { OtpModal } from "./otpModal";
import showPassImg from "../images/showPass.svg";
import hidePass from "../images/hidePass.svg";
import "./auth.css";

export const Login = ({ setSubsData, setSubsLoaded }) => {
  const alert = useAlert();
  const navigate = useNavigate();
  const { setUser } = userAction;
  const userStore = useSelector((state) => state.userReducer);
  const dispatch = useDispatch();

  const [showModal, setShowModal] = useState(false);
  const [showPass, setShowPass] = useState(false);

  const [data, setData] = useState({
    email: "",
    password: "",
  });
  const [loader, setLoader] = useState(false);

  const validators = () => {
    if (!data.email) {
      return "Email is required";
    }
    if (!data.password) {
      return "Password is required";
    }
    return false;
  };

  const onTextChange = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };

  const login = async (e) => {
    e.preventDefault();
    setLoader(true);

    try {
      const validatorsResponse = await validators();

      if (validatorsResponse) {
        throw new Error(validatorsResponse);
      }

      const payload = {
        email: data?.email.trim(),
        password: data?.password.trim(),
      };
      const registerationResponse = await api.login(payload);
      // console.log(registerationResponse);

      // if (!registerationResponse?.user?.emailVerified) {
      //   setShowModal(true);
      //   setLoader(false);
      //   return;
      // }

      axios.defaults.headers.common["Authorization"] =
        registerationResponse.token;

      const userId = registerationResponse?.user?._id;

      localStorage.setItem("token", registerationResponse.token);
      let isPaid = await checkSubs(userId);
      // console.log(isPaid);

      dispatch(setUser(registerationResponse));
      setLoader(false);
      isPaid ? navigate("/dashboard") : navigate("/checkout");
    } catch (e) {
      console.log(e.toString());
      if (
        e.message == "server not responding" ||
        e.message == "Network Error"
      ) {
        alert.show("PLEASE TRY AGAIN SHORTLY...");
      } else {
        alert.show(e.message);
      }
      // alert.show("Invalid Credentials or Account not verified");
      setLoader(false);
    }
  };

  const checkSubs = async (userId) => {
    setSubsLoaded?.(false);
    setLoader(true);
    // console.log("checksubs");

    const res = await api.checkSubscription(userId);
    // console.log(res);

    if (res?.subscription) {
      let currentDate = new Date();
      let endDate = new Date(res?.subscription?.nextPayment);
      if (currentDate < endDate) {
        res.subscription.isSubscription = true;
        setSubsData(res?.subscription);
        setSubsLoaded?.(true);
        return true;
      } else {
        res.subscription.isSubscription = false;
        setSubsData(res?.subscription);
        setSubsLoaded?.(true);
        return false;
      }
    }
    setSubsLoaded?.(true);
    setLoader(false);
    return false;
  };

  useEffect(() => {
    if (userStore?.users?.token) {
      navigate("/");
    }
  }, []);

  return (
    <>
      <div className="wzAuthStage">
        <div className="wzAuth-orb o1"></div>
        <div className="wzAuth-orb o2"></div>

        <div className="wzAuth-frame">
          <form noValidate id="contactForm" className="wzAuth-card">
            <div className="wzAuth-head">
              <div className="wzAuth-badge">&#128274;</div>
              <h1>Welcome Back</h1>
              <p>Log in to continue to your dashboard.</p>
            </div>

            <div className="wzAuth-form">
              <div>
                <label className="wzAuth-label" htmlFor="email">
                  Email
                </label>
                <div className="wzAuth-field">
                  <span className="ic">
                    <i className="fa-solid fa-envelope" />
                  </span>
                  <input
                    onChange={onTextChange}
                    value={data.email}
                    type="text"
                    name="email"
                    id="email"
                    required
                    placeholder="you@example.com"
                    className="wzAuth-input"
                  />
                </div>
              </div>

              <div>
                <label className="wzAuth-label" htmlFor="password">
                  Password
                </label>
                <div className="wzAuth-field pw">
                  <span className="ic">
                    <i className="fa-solid fa-lock" />
                  </span>
                  <input
                    onChange={onTextChange}
                    value={data.password}
                    type={showPass ? "text" : "password"}
                    name="password"
                    id="password"
                    required
                    placeholder="Enter your password"
                    className="wzAuth-input"
                  />
                  <button
                    type="button"
                    className="wzAuth-eye"
                    aria-label="Toggle password visibility"
                    onClick={() => setShowPass(!showPass)}
                  >
                    {showPass ? (
                      <img src={showPassImg} alt="" />
                    ) : (
                      <img src={hidePass} alt="" />
                    )}
                  </button>
                </div>
              </div>

              <div className="wzAuth-meta wzAuth-meta--end">
                <Link to={"/forget-password"}>Forgot password?</Link>
              </div>

              <button
                onClick={login}
                type="submit"
                className="wzAuth-submit"
                disabled={loader}
              >
                <span className="wzAuth-shine"></span>
                <span className="label">
                  {loader ? (
                    <>
                      <i
                        className="fa fa-spinner fa-pulse me-2"
                        style={{ position: "relative", top: "-0px" }}
                      ></i>
                      Signing in...
                    </>
                  ) : (
                    "Sign In"
                  )}
                </span>
              </button>

              <p className="wzAuth-foot">
                New here?{" "}
                <Link to={"/signup"}>
                  Create an account
                </Link>
              </p>
            </div>
          </form>
        </div>
      </div>
      <OtpModal show={showModal} setShow={setShowModal} email={data.email} />
    </>
  );
};
